<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      :loading="isLoading"
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem>
      <general-error v-if="!!generalError" />
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <user-info-view
          v-if="showUserInfo"
          :user="user" />
      <user-proxies
          v-if="showProxies"
          :user-id="userId" />
      <subscriptions
          v-if="showSubscriptions"
          :user-id="userId"
          @edited="getUserForAdmin" />
    </template>
  </tab-list>
</template>

<script>
  import Vue from 'vue'
  import UserInfoView from './UserInfoView.vue'
  import UserProxies from './UserProxies.vue'
  import Subscriptions from './Subscriptions.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { USER_TABS_ENUM } from '@/constants/enums'
  import { USER_TABS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      TabList,
      UserInfoView,
      UserProxies,
      Subscriptions,
      GeneralError
    },
    props: {
      userId: {
        type: String,
        required: true
      },
      tab: {
        type: String
      }
    },
    data () {
      return {
        isLoading: false,
        currentTab: this.tab || USER_TABS.USER_INFO,
        defaultTab: USER_TABS.USER_INFO
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        user: state => (state[USER_MANAGEMENT.STATE.CURRENT_USER] || {})
      }),
      tabs () {
        let tabs = { ...USER_TABS_ENUM }
        if (this.user.isTopManager || !this.user.isRegistered) {
          tabs = Vue.helpers.excludeObjectProps(tabs, [USER_TABS.PROXIES])
        }
        return tabs
      },
      title () {
        return this.$t('Просмотр пользователя')
      },
      showUserInfo () {
        return this.currentTab === USER_TABS.USER_INFO
      },
      showSubscriptions () {
        return this.currentTab === USER_TABS.SUBSCRIPTIONS
      },
      showProxies () {
        return this.currentTab === USER_TABS.PROXIES &&
          this.user.isRegistered && !this.user.isTopManager
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.userId) {
          return
        }
        vm.getUserForAdmin()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserForAdminAction: USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN,
        clearUserForAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN
      }),
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/user/${this.userId}/${tabValue}`
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserForAdminAction()
          ])
      },
      getUserForAdmin: async function () {
        this.isLoading = true
        try {
          await this.getUserForAdminAction({
            userId: this.userId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
